import { Button } from '@/components/ui/button';
import { useAppearance } from '@/hooks/use-appearance';
import { cn } from '@/lib/utils';
import { Moon, Sun } from 'lucide-react';

interface ThemeToggleProps {
    className?: string;
}

export default function ThemeToggle({ className }: ThemeToggleProps) {
    const { appearance, toggleAppearance } = useAppearance();
    const isDark = appearance === 'dark';
    const label = isDark ? 'Switch to light mode' : 'Switch to dark mode';

    return (
        <Button
            type="button"
            variant="bare"
            size="bare"
            onClick={toggleAppearance}
            aria-label={label}
            title={label}
            className={cn(
                'flex size-9 shrink-0 cursor-pointer items-center justify-center rounded-full transition-colors',
                className,
            )}
        >
            {isDark ? <Sun className="size-5" /> : <Moon className="size-5" />}
        </Button>
    );
}
